import { retailerSettingsService } from '../services/retailer-settings/retailer-settings';

const customStylesTemplate = (style) => `
  html {
    font-size: 16px;
  }

  body {
    background-color: ${style?.body_bg}
  }

  .header_nav {
    background-color: ${style?.header_bg}
  }

  .header-menu-link {
    color: ${style?.header_text_color}
  }

  html, body, button, input, select, textarea, p, a, h2 {
    font-family: ${style?.font_family_primary};
  }

  input {
    color: #000;
  }

  a, a:hover, a:focus {
    color: ${style?.link_color};
  }

  .sidebar-comments {
    height: 100px;
    border-radius: 2px;
  }

  .error-message {
    background-color: ${style?.brand_call_to_action};
  }

  .order-number:focus,
  .billing-zip:focus,
  .secondary-email-input:focus,
  .sidebar-comments:focus,
  .sidebar-comments textarea:focus {
    outline: 1px solid ${style?.brand_call_to_action};
  }

  .location-card .store-name-container:focus,
  .return-item-container:focus,
  .return-method-container:focus {
    outline: 5px auto -webkit-focus-ring-color;
    outline-offset: -2px;
  }

  .returns-help-button {
    background-color: ${style?.brand_call_to_action};
  }

  .order-number.input-error,
  .billing-zip.input-error {
    border-color: ${style?.brand_call_to_action};
  }

  .error-text {
    color: ${style?.brand_call_to_action};
  }

  .narvar-btn-primary {
    background-color: ${style?.brand_call_to_action};
    color: #ffffff;
  }

  .narvar-btn-primary:hover, .narvar-btn-primary:active, .narvar-btn-primary:focus, .narvar-btn-primary:active:focus {
    background-color: color-mix(in srgb, ${style?.brand_call_to_action}, black 10%);
    color: #ffffff;
  }

  .narvar-spinner {
    fill: ${style?.brand_call_to_action};
  }

  .narvar-btn-primary .narvar-spinner {
    fill: #fff;
  }

  .narvar-btn-secondary {
    background-color: #ffffff;
    color: ${style?.brand_call_to_action};
    border-color: ${style?.brand_call_to_action};
  }

  .narvar-btn-secondary:hover, .narvar-btn-secondary:active, .narvar-btn-secondary:focus, .narvar-btn-secondary:active:focus {
    background-color: #ffffff;
    color: color-mix(in srgb, ${style?.brand_call_to_action}, black 10%);
    outline: thin solid color-mix(in srgb, ${style?.brand_call_to_action}, black 10%);
  }

  .return-item-container, .return-method-container {
    outline: none;
  }

  .return-eligible-item.selected-item,
  .return-method-container.selected-method {
    border-color: ${style?.brand_call_to_action};
  }

  .return-eligible-item:hover,
  .return-method-container:hover {
    border-color: color-mix(in srgb, ${style?.brand_call_to_action}, black 10%);
  }

  .selected-item, .selected-method {
    border-width: 3px;
  }

  .narvar-btn-tertiary {
    background-color: #ffffff;
    color: ${style?.brand_call_to_action};
    border: none;
  }

  .narvar-btn-tertiary:hover, .narvar-btn-tertiary:active, .narvar-btn-tertiary:focus, .narvar-btn-tertiary:active:focus {
    background-color: #ffffff;
    color: color-mix(in srgb, ${style?.brand_call_to_action}, black 10%);
    border: none;
  }

  .sidebar-panel-header {
    background-color: ${style?.brand_primary};
  }

  .sidebar-panel-header svg {
    max-height: 20px;
  }

  .returns-sidebar-icon {
    fill: #fff;
  }

  .breadcrumb-fill, .success-checkmark-icon, .success-checkmark-overlay {
    fill: ${style?.brand_call_to_action};
  }

  .cta-icon {
    fill: ${style?.brand_call_to_action};
  }

  /* Checkmark Styles */
  .narvar-checkmark .checkmark-fill {
    fill: #fff;
  }

  .narvar-checkmark.checkmark-selected .checkmark-fill,
  .narvar-checkmark.checkmark-selected .checkmark-outline {
    fill: ${style?.brand_call_to_action};
  }

  .return-item-container:hover .narvar-checkmark .checkmark,
  .return-item-container:hover .narvar-checkmark.checkmark-selected .checkmark-fill,
  .return-method-container:hover .narvar-checkmark .checkmark,
  .return-method-container:hover .narvar-checkmark.checkmark-selected .checkmark-fill {
    fill: color-mix(in srgb, ${style?.brand_call_to_action}, black 10%);
  }

  .return-item-container:hover .narvar-checkmark.checkmark-selected .checkmark-icon,
  .return-method-container:hover .narvar-checkmark.checkmark-selected .checkmark-icon,
  .narvar-checkmark.checkmark-selected .checkmark-icon {
    fill: #fff;
  }

  .sidebar-return-qty {
    border-color: ${style?.brand_call_to_action};
    height: 40px;
  }

  .sidebar-return-qty:focus {
    border-color: color-mix(in srgb, ${style?.brand_call_to_action}, black 10%);
  }

  .option_input:checked + .option_label:before {
    background-color: ${style?.brand_call_to_action};
  }

  .option_checkbox:checked + .option_label:before {
    border-color: color-mix(in srgb, ${style?.brand_call_to_action}, black 10%);
  }

  .sidebar-action-btn {
    font-family: ${style?.font_family_primary};
  }
`;

const addCustomStylesToHead = () => {
  const style = retailerSettingsService.getStyle();
  const styleElement = document.createElement('style');
  styleElement.innerHTML = customStylesTemplate(style);
  document.head.appendChild(styleElement);
};

export { addCustomStylesToHead };
